import { render } from "./doctor-dashboard.vue?vue&type=template&id=6f6c7e3d&scoped=true"
import script from "./doctor-dashboard.vue?vue&type=script&lang=js"
export * from "./doctor-dashboard.vue?vue&type=script&lang=js"

import "./doctor-dashboard.vue?vue&type=style&index=0&id=6f6c7e3d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6c7e3d"]])

export default __exports__